import { CommonModule } from '@angular/common'
import { Component, ElementRef, EventEmitter, Output } from '@angular/core'
import { AdvancedSearchMultiOption, AdvancedSearchOption, } from '../../types'
import { TranslocoDirective } from '@jsverse/transloco'
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms'

@Component({
   selector: 'app-search-dropdown',
   standalone: true,
   imports: [CommonModule, FormsModule, TranslocoDirective],
   templateUrl: './search-dropdown.component.html',
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         multi:true,
         useExisting: SearchDropdownComponent
      }
   ]
})
export class SearchDropdownComponent implements ControlValueAccessor {

   @Output() selected = new EventEmitter<AdvancedSearchOption>()
   onChange!: (obj: AdvancedSearchMultiOption) => void
   onTouched!: () => void

   multiOption!: AdvancedSearchMultiOption
   options!: AdvancedSearchOption[]

   writeValue(obj: AdvancedSearchMultiOption): void {
      this.multiOption = obj
      this.options = obj.options
   }

   registerOnChange(fn: (obj: AdvancedSearchMultiOption) => void): void {
      this.onChange = fn
   }

   registerOnTouched(fn: () => void): void {
      this.onTouched = fn
   }

   constructor(private _elementRef: ElementRef) { }

   onChanged = ($event: Event) => {
      const el = $event.target as HTMLSelectElement
      const option = this.multiOption.options.find((o) => o.value === el.value)
      if (option) {
         if(this.multiOption.defaultValue === el.value) {
            this.multiOption.selected = null
         }
         else {
            this.multiOption.selected = el.value
         }
         this.selected.emit(option)
         this.onChange(this.multiOption)
      }
   }

   // for the initial rendering of the select dropdown, we need to set the selected value
   isSelected(option: AdvancedSearchOption) {
      return this.multiOption.selected === option.value
   }

   getClass(): string[] {
      let classNames = ['t-search-dropdown-' + this.multiOption.translationPrefix.replace('dropdown.', '')]
      if (this.multiOption.selected) {
         classNames = [...classNames, 'font-bold', 'text-cdra-blue-light-700']
      }
      return classNames
   }

}
